import { all, put, takeEvery } from "redux-saga/effects";

import { analyticsStoreEvent } from "@/mk2/actions";
import {
    SELL_EXPERIENCE_POPUP_CLOSE,
    SELL_EXPERIENCE_POPUP_SHOW,
    SELL_EXPERIENCE_POPUP_WRITE,
    SellExperiencePopupCloseAction,
    SellExperiencePopupShowAction,
    SellExperiencePopupWriteAction,
} from "@/mk2/apps/bazaar/containers/SellExperiencePopup/SellExperiencePopup.actions";

function* show({ productId }: SellExperiencePopupShowAction) {
    yield put(
        analyticsStoreEvent("sell_experience_popup", {
            action: "show",
            product_id: productId,
        }),
    );
}

function* write({ productId }: SellExperiencePopupWriteAction) {
    yield put(
        analyticsStoreEvent("sell_experience_popup", {
            action: "click",
            product_id: productId,
        }),
    );
}

function* close({ productId }: SellExperiencePopupCloseAction) {
    yield put(
        analyticsStoreEvent("sell_experience_popup", {
            action: "close",
            product_id: productId,
        }),
    );
}

export default function* root() {
    yield all([
        takeEvery(SELL_EXPERIENCE_POPUP_SHOW, show),
        takeEvery(SELL_EXPERIENCE_POPUP_WRITE, write),
        takeEvery(SELL_EXPERIENCE_POPUP_CLOSE, close),
    ]);
}
